<div class="container-fluid" (keydown)="onKeydown($event)">
  <div class="row">
    <div class="col-md-4 "></div>
    <div class="col-sm-12 col-md-4">
      <div class="container-login" style="width: 100%; margin-top: 50px; text-align: center">
        <div class="imagen-login-container">
          <img class="imagen-login" src="../../../assets/img/captarmedia-login.png">
        </div>
        <div class="form-login">
          <ngb-alert [type]="alertType" *ngIf="successMessage" (close)="successMessage = null"><h5>{{ successMessage }}</h5></ngb-alert><hr/>
          <form [formGroup]="form" (ngSubmit)="changePass()">
            <input formControlName="username" type="email" class="input-login" placeholder="Ingrese su email">
            <div *ngIf="form.get('username').touched && form.get('username').invalid" class="text-danger small">
              <span *ngIf="form.get('username').errors?.required">El email es requerido</span>
              <span *ngIf="form.get('username').errors?.email">Ingrese un email válido</span>
            </div>
            <input formControlName="newPass" type="password" class="input-login" placeholder="Ingrese la nueva contraseña">
            <div *ngIf="form.get('newPass').touched && form.get('newPass').invalid" class="text-danger small">
              <span *ngIf="form.get('newPass').errors?.required">La nueva contraseña es requerida</span>
              <span *ngIf="form.get('newPass').errors?.minlength">La contraseña debe tener al menos 6 caracteres</span>
            </div>
            <input formControlName="confirmPass" type="password" class="input-login" placeholder="Confirme la nueva contraseña">
            <div *ngIf="form.get('confirmPass').touched && form.get('confirmPass').invalid" class="text-danger small">
              <span *ngIf="form.get('confirmPass').errors?.required">Debe confirmar la contraseña</span>
            </div>
            <div class="row container-button">
              <button type="submit" class="button-login" [disabled]="pending">CAMBIAR CONTRASEÑA</button>
            </div>
          </form>
          <a class="link-login" *ngIf="successMessage && alertType === 'success'" (click)="irALogin()">Volver al inicio de sesión</a>
        </div>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/recovery-pass/recovery-pass.component.html